<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div *ngIf="supportedLineTypes" class="lines-list">
    <winde-ctx-sensitive-help
            *ngFor="let line of supportedLineTypes"
            [tooltipTextPath]="'projectView.los.' + line.class"
            container="div.step--2"
    >
        <button
                (click)="historyService.isEditModeEnabled ? modeChanged(line.type) : false"
                [ngClass]="{ 'line-container-disabled': !historyService.isEditModeEnabled }"
                class="line-container btn-no-style"
        >
            <div [ngClass]="{ 'line-selected': historyService.toolbarMode === line.type }" class="{{ line.class }}"></div>
        </button>
    </winde-ctx-sensitive-help>
    <div class="toolbar-row item_row">
        <button (click)="autoconnect()" [disabled]="!historyService.isEditModeEnabled" class="btn btn-link btn-sm btn-autoconnect">
            Auto-connect
        </button>
        <button
                [disabled]="!historyService.isEditModeEnabled"
                [routerLink]="['/', { outlets: { popup: 'project-view/auto-connect' } }]"
                class="btn-autoconnect-conf btn btn-no-style"
        >
            <winde-ctx-sensitive-help container="div.step--2" tooltipTextPath="projectView.los.btn.autoConnect">
                <button windeActionIcon>
                    <sui-svg-icon icon="cog" windeGrey/>
                </button>
            </winde-ctx-sensitive-help>
        </button>
    </div>

    <button (click)="exportKmlFile()" class="btn btn-link btn-sm btn-export-kml item_row">Export KML file</button>

    <button (click)="exportSites('xlsx', true)" class="btn btn-link btn-sm btn-export-kml item_row">Export sites with LoS-es</button>

    <div class="item_row">
        <div class="export-sites-label">Export sites as:</div>
        <div class="export-sites-btns">
            <button (click)="exportSites('csv', false)" class="btn btn-link btn-sm btn-export-sites-csv">CSV</button>
            <span>|</span>
            <button (click)="exportSites('xlsx', false)" class="btn btn-link btn-sm btn-export-sites-xlsx">XLSX</button>
        </div>
    </div>


    <button
            [routerLink]="['/', { outlets: { popup: 'project-view/disabled-entities' } }]"
            class="btn btn-link btn-sm btn-disabled-entities item_row"
    >
        Show disabled
    </button>
</div>
